/**
 * @changelog
 *
 * 2026-09-08 (0.1.0) (jhoward)
 *   - Add src\helpers\getSelectedPrize.ts, holding the CASINO_PRIZE_ID matching rule that was inline in
 *     src\components\offers\DisplayPrizes.vue so the offer status text and the prize list cannot disagree.
 */

import type { OpcOffer } from '@/defs/api/OpcOffer';
import type { OpcPrize } from '@/defs/api/OpcPrize';

/**
 * CASINO_PRIZE_ID is a pipe-joined composite - "19201|Concert Hall|2025-10-30 21:00:00|2025-10-30 23:59:00" - while
 * PRIZE_ID_SELECTED is just the numeric id at the front of it, so the two are compared on that first segment.
 */
export function isPrizeSelected(offer: OpcOffer, prizeId: string): boolean {
  return (
    null !== offer.PRIZE_ID_SELECTED &&
    prizeId.substring(0, offer.PRIZE_ID_SELECTED.toString().length + 1) === offer.PRIZE_ID_SELECTED.toString() + '|'
  );
}

export default function getSelectedPrize(offer: OpcOffer): OpcPrize | null {
  if (null === offer.PRIZE_ID_SELECTED || !offer._PRIZES?.length) {
    return null;
  }

  return offer._PRIZES.find((prize) => isPrizeSelected(offer, prize.CASINO_PRIZE_ID)) ?? null;
}
